<template>
  <bcc-dialog
    :visible="true"
    width="600px"
    :lock-scroll="true"
    @close="clickClose"
  >
    <div slot="title" class="scope-add-title">API组权限申请</div>
    <div slot="default" class="scope-add-form">
      <div class="scope-add-form-item">
        <span class="label">
          <i class="required">*</i>API组名称
        </span>
        <bcc-select placeholder="请选择" width="248px" v-model="scopes_key" :disabled="lockScopesKey">
          <bcc-option v-for="(option, idx) in scopes_key_options" :key="idx" :label="option.label" :value="option.value" />
        </bcc-select>
      </div>
      <div class="scope-add-form-textarea-item">
        <span class="label">
          <i class="required">*</i>申请理由
        </span>
        <bcc-input
          maxlength="80"
          style="width: 444px;"
          rows="6"
          type="textarea"
          placeholder="请输入申请理由"
          v-model="apply_reason"
          showWordLimit
        ></bcc-input>
      </div>
    </div>
    <div slot="footer" class="scope-add-footer">
      <bcc-button @click="clickOK" style="margin-right: 10px;" :disabled="addLoading || (!scopes_key || !apply_reason)" size="large" type="primary">确定</bcc-button>
      <bcc-button @click="clickClose" style="margin-left: 10px;" class="scope-add-footer-cancel" size="large">取消</bcc-button>
    </div>
  </bcc-dialog>
</template>

<script>
export default {
  name: "scope-add",
  data() {
    return {
      scopes_key: '',
      apply_reason: '',
      addLoading: false,
      lockScopesKey: false
    }
  },
  props: {
    scopes_key_options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  created() {
  },
  methods: {
    clickOK() {
      if (!this.scopes_key) {
        this.$message({
          content: '请选择API组',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        return
      }
      if (!this.apply_reason) {
        this.$message({
          content: '请填写申请理由',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        return
      }
      this.addLoading = true
      this.$api.companyScope.submit({
        client_id: this.$route.params.client_id,
        scopes: this.scopes_key + '',
        apply_reason: this.apply_reason
      }).then(() => {
        this.$emit('ok')
        this.addLoading = false
      }).catch((e) => {
        this.addLoading = false
        this.$message({
          content: e.message || '申请API组错误',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        if (e.message === '应用认证未通过') {
          this.$router.push({path: '/company-core'})
        }
      })
    },
    clickClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.scope-add-form-item {
  display: flex;
  margin-bottom: 32px;
  align-items: center;
}

.scope-add-form-textarea-item {
  display: flex;
  .label {
    margin-top: 10px;
  }
}

.label {
  font-size: 14px;
  color: #212121;
  display: inline-block;
  width: 90px;
}
.required {
  color: #FA5A57;
  margin-right: 4px;
}
</style>
